import { useEffect, useRef, useState } from 'react'
import {
	hasSupport,
	updatePositioningWithLib
} from 'shared/polyfills/positioning'

import css from './QuickActions.module.scss'
import { menu, openId } from './utils/open'
export function useOpened(id = '') {
	const triggerRef = useRef<HTMLButtonElement | null>(null)
	const [isOpen, setIsOpen] = useState(false)

	useEffect(() => {
		let unmount: (() => void) | null = null

		const unobserve = openId.subscribe(() => {
			const isSame = id === openId.value
			if (hasSupport) {
				setIsOpen(isSame)

				unmount = () => setIsOpen(false)
			} else {
				if (!isSame && menu && triggerRef.current) {
					unmount?.()

					updatePositioningWithLib(triggerRef.current, menu).then(
						unsubscribe => {
							unmount = unsubscribe
						}
					)
				}
			}
		})

		return () => {
			unmount?.()
			unobserve()
		}
	}, [id])

	return {
		isOpen,
		openClass: isOpen && css.currentAnchor,
		triggerRef
	}
}
